import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "account-modal__content" }
const _hoisted_2 = {
  key: 0,
  class: "account-modal__buttons"
}

import { computed } from "vue";
import ModalPopup from "@/shared/components/modal-popup.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import { BasicIcons } from "@/components/shared/assets/basic-icons";
import { AccountModalType } from "@/account/models/account-modal-type";


export default /*@__PURE__*/_defineComponent({
  __name: 'account-modal',
  props: {
    modelValue: { type: Boolean },
    modalType: { default: AccountModalType.Basic },
    confirmButtonTitle: { default: "Potvrdit" },
    confirmButtonIcon: {},
    confirmButtonTypeClass: { default: "btn-secondary" },
    closeButtonTypeClass: { default: "btn-blue" }
  },
  emits: ["update:modelValue", "confirmButtonClicked"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const updateModelValue = (value: boolean) => emit("update:modelValue", value);

const showConfirmButton = computed(() => props.modalType == AccountModalType.Confirmation);
const showCloseModalButton = computed(
    () => props.modalType == AccountModalType.Confirmation || props.modalType == AccountModalType.Information
);

const confirmButtonClicked = () => emit("confirmButtonClicked");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalPopup, {
    class: "account-modal",
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": updateModelValue
  }, {
    default: _withCtx(() => [
      _createVNode(WebpImage, {
        class: "account-modal__logo",
        src: "/frontend/kasa-loyalty/img/static/logo.svg",
        alt: "Sazka logo",
        width: "82",
        height: "82"
      }),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        (showConfirmButton.value || showCloseModalButton.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("button", {
                class: _normalizeClass(["btn", _ctx.confirmButtonTypeClass]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmButtonClicked()))
              }, [
                (_ctx.confirmButtonIcon)
                  ? (_openBlock(), _createBlock(KasaIcon, {
                      key: 0,
                      name: _ctx.confirmButtonIcon,
                      width: 20,
                      height: 20
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.confirmButtonTitle), 1)
              ], 2), [
                [_vShow, showConfirmButton.value]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: _normalizeClass(["btn", _ctx.closeButtonTypeClass]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (updateModelValue(false)))
              }, " Zavřít ", 2), [
                [_vShow, showCloseModalButton.value]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})